<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h2 class="fm-title">Foreword</h2>
<p class="noindent"><span class="dropcaps">T</span>he reign of <em class="italic">SS-Obergruppenführer</em> Reinhard Heydrich in Bohemia and Moravia will forever remain in the history of the Second World War as a period of terror, immense brutality and mass killings of Czech citizens. However, it was also a time of great solidarity and heroism among the Czech people in spite of the deaths of thousands of innocent men, women and children. The population lived in daily fear for themselves and their loved ones, but despite the constant trepidation, resistance to Nazism was strong in Czechoslovakia.</p>
<p class="indent">One of the most powerful Nazis of the Third Reich, Reinhard Heydrich, who became protector of Bohemia and Moravia in September 1941, soon earned the nickname of ‘the executioner of the Czech nation’ and ‘the Butcher of Prague’.</p>
<p class="indent">However, after only eight months in office, Heydrich would be attacked in Prague on 27 May 1942 by two Czech paratroopers, Jozef Gabčík and Jan Kubiš. Heydrich would later die from his injuries and as a result there were brutal consequences for the Czech citizens and terrible reprisals would follow.</p>
<p class="indent">This book is the story of Reinhard Heydrich’s rise to power. He became the darkest figure within the Nazi regime and would become known by his Führer as the man with the iron heart.</p>
<p class="indentt">Michal Výborný</p>
<p class="indent">Prague</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Foreword.vue?e3208b02